import { PaymentType } from "@1games-ru/region-shared/dist/enums/payment/payment";
import { useLayoutEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { BankCardIcon, CashIcon } from "@/shared/icons";

type Props = {
  value: PaymentType;
  onChange: (value: PaymentType) => void;
};

export default function GasStationPaymentType({ value, onChange }: Props) {
  const { t } = useTranslation("gasStation");
  const [activeTabBlockStyle, setActiveTabBlockStyle] = useState({ width: 0, left: 0 });
  const refs = useRef([]);

  const values = useMemo(() => {
    return [PaymentType.Card, PaymentType.Cash];
  }, []);

  useLayoutEffect(() => {
    const index = values.findIndex((item) => item === value);
    if (refs.current[index]) {
      const activeTabElement = refs.current[index];
      const { offsetWidth, offsetLeft } = activeTabElement;

      setActiveTabBlockStyle({
        width: offsetWidth,
        left: offsetLeft,
      });
    }
  }, [value, values]);

  return (
    <div className="flex flex-col gap-3.5">
      <div className="text-12 font-medium text-white uppercase">{t("gasStation.paymentType")}:</div>
      <div
        className="relative grid h-[2.75rem] bg-dark-800 rounded-[0.5rem]"
        style={{
          gridTemplateColumns: `repeat(${values.length}, 1fr)`,
        }}
      >
        {values.map((item, index) => (
          <button
            key={item}
            type="button"
            className={clsx(
              "h-full flex items-center gap-1.5 justify-center text-15 font-medium rounded-[0.5rem] z-1 transition",
              item === value ? "text-accent-solid-text" : "text-white/75 hover:text-white",
            )}
            onClick={() => onChange(item)}
            aria-checked={value === item}
            ref={(el) => {
              refs.current[index] = el;
              return el;
            }}
          >
            {item === PaymentType.Cash && <CashIcon size={24} />}
            {item === PaymentType.Card && <BankCardIcon size={24} />}
            {t(`gasStation.paymentMethod.${item.toLowerCase()}`)}
          </button>
        ))}
        <div
          className="btn variant-solid-gradient absolute h-full rounded-[0.5rem] transition-all duration-300 z-0"
          style={{
            width: `${activeTabBlockStyle.width}px`,
            transform: `translateX(${activeTabBlockStyle.left}px)`,
          }}
        />
      </div>
    </div>
  );
}
